export default {
  name: process.env.REACT_APP_NAME as string,
  version: process.env.REACT_APP_VERSION as string,
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL as string,
  apiUploadUrl: process.env.REACT_APP_API_UPLOAD_URL as string,
  sentryKey: process.env.REACT_APP_SENTRY_KEY as string,
};
